import { Divider } from "@components"
import { Input, Textarea } from "@heroui/react"
import { PropTypes } from "prop-types"

const EmailForm = ({ form, handleUpdateForm }) => (
  <div className='flex flex-col gap-y-4'>
    <Input 
      label="Email Subject (Max 50 characters)"
      labelPlacement="outside"
      isRequired
      maxLength={50}
      minLength={3}
      placeholder="Enter your email subject" 
      type="text" 
      value={form.title}
      onValueChange={(value) => handleUpdateForm("title", value)}
    />

    <Divider />

    <Textarea
      label="Email Body (Max 2000 characters)"
      labelPlacement="outside"
      isRequired
      minRows={7}
      minLength={10}
      maxRows={8}
      maxLength={2000}
      placeholder="Enter you email text"
      value={form.description}
      onValueChange={(value) => handleUpdateForm("description", value)}
    />
  </div>
)

EmailForm.propTypes = {
  form: PropTypes.shape({
    description: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
  handleUpdateForm: PropTypes.func.isRequired,
}

export default EmailForm